define.alias("shared/components/shared/pinterest-business", "media/components/shared/pinterest-business");